import { render } from "./TrainingRegister.vue?vue&type=template&id=8124edac&scoped=true&lang=pug"
import script from "./TrainingRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingRegister.vue?vue&type=script&setup=true&lang=js"

import "./TrainingRegister.vue?vue&type=style&index=0&id=8124edac&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8124edac"]])

export default __exports__